// React
import React, { useEffect, useState } from 'react';
import { CardBody, Row, Col, Label, Input } from 'reactstrap';

// Containers
import {
  SelectInput,
  InputCpfCnpj,
} from '../../../../../../containers/componentsInjection';

// Utils
import { cpf } from 'cpf-cnpj-validator';

const DependentRow = ({
  index,
  kinships,
  onRemove,
  dependente,
  onCpfChange,
  onFieldChange,
  onSelectChange,
  isAnyDependentFieldRequired,
  isValidDependentCpf,
}) => (
  <Row key={index}>
    <Col md={3}>
      <div className="mb-3">
        <Label htmlFor={`cpf${index}`} className="form-label">
          CPF
        </Label>
        <InputCpfCnpj
          id={`cpf${index}`}
          name="cpf"
          isCPF={true}
          className="form-control bg-light border-0"
          value={dependente.cpf || ''}
          onChange={(e, type) => {
            if (type === 'CPF') {
              onCpfChange(index, e);
            }
          }}
          invalid={isAnyDependentFieldRequired?.[index]?.cpf && !dependente.cpf}
        />
        {!isValidDependentCpf[index] && (
          <small className="labelErrorValidation">Digite um CPF válido</small>
        )}
      </div>
    </Col>

    <Col md={4}>
      <div className="mb-3">
        <Label htmlFor={`name${index}`} className="form-label">
          Nome
        </Label>
        <Input
          type="text"
          className="form-control bg-light border-0"
          id={`name${index}`}
          name="name"
          onChange={(e) => onFieldChange(index, e)}
          value={dependente.name || ''}
          invalid={
            isAnyDependentFieldRequired?.[index]?.name && !dependente.name
          }
        />
      </div>
    </Col>

    <Col md={2}>
      <div className="mb-3">
        <Label htmlFor={`birth${index}`} className="form-label">
          Data nascimento
        </Label>
        <Input
          type="date"
          className="form-control bg-light border-0"
          id={`birth${index}`}
          name="birth"
          onChange={(e) => onFieldChange(index, e)}
          value={dependente.birth || ''}
          invalid={
            isAnyDependentFieldRequired?.[index]?.birth && !dependente.birth
          }
        />
      </div>
    </Col>

    <Col md={2}>
      <div className="mb-3">
        <Label htmlFor={`kinship${index}`} className="form-label">
          Parentesco
        </Label>
        <SelectInput
          isClearable
          options={kinships}
          value={dependente.kinship}
          onChange={(eventInput) =>
            onSelectChange(index, 'kinship', eventInput)
          }
          inputId={`kinship${index}`}
          name="kinship"
          className="form-control bg-light border-0"
          invalid={
            isAnyDependentFieldRequired?.[index]?.kinship && !dependente.kinship
          }
        />
      </div>
    </Col>

    <Col className="mt-3 pt-3">
      <i
        className="las la-minus-circle text-danger fs-20 mt-1"
        role="button"
        onClick={() => onRemove(index)}
      ></i>
    </Col>
  </Row>
);

export const ProposalDependentsSection = ({
  kinships,
  dependents,
  setDependents,
  maxDependents,
  initialDependents,
  isValidDependentCpf,
  setIsValidDependentCpf,
  isAnyDependentFieldRequired,
  setIsAnyDependentFieldRequired,
}) => {
  const handleAddDependente = () => {
    setDependents([
      ...dependents,
      { cpf: '', name: '', birth: '', kinship: '' },
    ]);
    setIsValidDependentCpf([...isValidDependentCpf, true]);
    setIsAnyDependentFieldRequired([
      ...isAnyDependentFieldRequired,
      { cpf: false, name: false, birth: false, kinship: false },
    ]);
  };

  const handleRemoveDependente = (index) => {
    setDependents(dependents.filter((_, i) => i !== index));
    setIsValidDependentCpf(isValidDependentCpf.filter((_, i) => i !== index));
    setIsAnyDependentFieldRequired(
      isAnyDependentFieldRequired.filter((_, i) => i !== index)
    );
  };

  const handleCpfChange = (index, e) => {
    const updatedDependentes = [...dependents];
    updatedDependentes[index].cpf = e.target.value;
    setDependents(updatedDependentes);

    const updatedIsValidCpf = [...isValidDependentCpf];
    const isCpfEmpty = e.target.value === '';
    const isCpfValid = cpf.isValid(e.target.value);
    updatedIsValidCpf[index] = isCpfEmpty || isCpfValid;
    setIsValidDependentCpf(updatedIsValidCpf);

    updateFieldRequirements(index, updatedDependentes);
  };

  const handleFieldChange = (index, e) => {
    const { name, value } = e.target;
    const updatedDependentes = [...dependents];
    updatedDependentes[index][name] = value;
    setDependents(updatedDependentes);

    updateFieldRequirements(index, updatedDependentes);
  };

  const handleSelectChange = (index, name, value) => {
    const updatedDependentes = [...dependents];
    updatedDependentes[index][name] = value;
    setDependents(updatedDependentes);

    updateFieldRequirements(index, updatedDependentes);
  };

  const updateFieldRequirements = (index, updatedDependentes) => {
    const dependente = updatedDependentes[index];

    const isAnyFieldFilled = Object.values(dependente).some(
      (val) => val !== '' && val !== null && val !== undefined
    );

    const updatedIsFieldRequired = [...isAnyDependentFieldRequired];
    updatedIsFieldRequired[index] = {
      cpf: isAnyFieldFilled && !dependente.cpf,
      name: isAnyFieldFilled && !dependente.name,
      birth: isAnyFieldFilled && !dependente.birth,
      kinship: isAnyFieldFilled && !dependente.kinship,
    };
    setIsAnyDependentFieldRequired(updatedIsFieldRequired);
  };

  const verifyIfCanAddMoreDependents = () => dependents.length < maxDependents;

  useEffect(() => {
    if (initialDependents && kinships.length > 0) {
      const formattedDependents = initialDependents.map((dependente) => ({
        cpf: dependente.cpf,
        name: dependente.nome,
        birth: dependente.birthdate,
        kinship: kinships.find(
          (kinship) => kinship.value === dependente.kinship_id
        ),
      }));
      setDependents(formattedDependents);

      const initialIsValidCpf = formattedDependents.map((dependente) =>
        cpf.isValid(dependente.cpf)
      );
      setIsValidDependentCpf(initialIsValidCpf);

      const initialIsFieldRequired = formattedDependents.map(() => ({
        cpf: false,
        name: false,
        birth: false,
        kinship: false,
      }));
      setIsAnyDependentFieldRequired(initialIsFieldRequired);
    }
  }, [
    kinships,
    setDependents,
    initialDependents,
    setIsValidDependentCpf,
    setIsAnyDependentFieldRequired,
  ]);

  return (
    <CardBody className="border-bottom border-bottom-dashed p-4">
      <Col md={12} className="mb-4">
        <h4 className="mb-1">Dependentes</h4>
      </Col>
      {dependents.map((dependente, index) => (
        <DependentRow
          key={index}
          index={index}
          kinships={kinships}
          dependente={dependente}
          onCpfChange={handleCpfChange}
          onFieldChange={handleFieldChange}
          onRemove={handleRemoveDependente}
          isAnyDependentFieldRequired={isAnyDependentFieldRequired}
          onSelectChange={handleSelectChange}
          isValidDependentCpf={isValidDependentCpf}
        />
      ))}

      <button
        type="button"
        onClick={() => {
          if (verifyIfCanAddMoreDependents()) handleAddDependente();
        }}
        className={`btn btn-primary ${dependents.length > 0 && 'mt-3'}`}
        disabled={!verifyIfCanAddMoreDependents()}
      >
        Adicionar dependente
      </button>
      {!verifyIfCanAddMoreDependents() && (
        <p className="text-danger mt-2">Limite de dependentes atingido</p>
      )}
    </CardBody>
  );
};
